import SlimSelect from "slim-select";

function createOptionPlaceholder(select, placeholder) {
  const hasSelectedOption = Array.from(select.options).some(
    (option) => option.getAttribute("selected") // check selected attribute from .net
  );

  if (!hasSelectedOption) {
    const placeholderOption = document.createElement("option");
    placeholderOption.textContent = placeholder;
    placeholderOption.value = "";
    placeholderOption.selected = true;
    placeholderOption.setAttribute("data-placeholder", "true");
    select.prepend(placeholderOption);
  }
}

export default function Selects() {
  document.querySelectorAll("select").forEach(function (element) {
    if (element.id == "finishes") return;
    if (
      element.nextSibling.classList &&
      element.nextSibling.classList.contains("ss-main")
    )
      return;
    if (!element.classList.contains("searchable-select")) {
      const placeholder = element.getAttribute("ss-placeholder");

      if (placeholder) {
        createOptionPlaceholder(element, placeholder);
      }

      new SlimSelect({
        select: element,
        class: "custom-selects",
        settings: {
          showSearch: false,
        },
        onChange: (info) => {
          if (typeof info.data.src != "undefined" && info.data.src != "") {
            window.location.href = info.data.src;
          }
        },
      });
    } else {
      new SlimSelect({
        select: element,
        class: "custom-selects",
        settings: {
          showSearch: true,
          searchPlaceholder: element.hasAttribute("ss-searchPlaceholder")
            ? element.getAttribute("ss-searchPlaceholder")
            : "",
          searchText: element.hasAttribute("ss-searchText")
            ? element.getAttribute("ss-searchText")
            : "Sorry, no results found",
          searchHighlight: true,
        },
      });
    }
  });
}
